import Recat from 'react'
import {Component} from 'react'
import { ExternalLink } from 'react-external-link';

export default function Copyright(){
  return(
    <div>
    <hr style={{
            color: "white", marginBottom:"-4px", paddingnTop:"4px"}}/>
<p style={{textAlign: "center", color:"grey", padding: "3rem"}}> © Developed by <ExternalLink href="https://www.linkedin.com/in/arzamaan-hussain-898317197/" style={{textDecoration:"none", color:"white"}}> <span >Arzamaan</span></ExternalLink></p>
    </div>
  )
}
